var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcForward15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#020203;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,0C14.3,0,0,14.3,0,32s14.3,32,32,32s32-14.3,32-32S49.7,0,32,0z M32,60C16.6,60,4,47.4,4,32S16.6,4,32,4 c15.4,0,28,12.6,28,28S47.4,60,32,60z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.3,42.1V26.6h-2.5c-0.1,0.6-0.3,1.1-0.6,1.5c-0.3,0.4-0.6,0.7-1,1c-0.4,0.2-0.9,0.4-1.4,0.5 c-0.5,0.1-1,0.1-1.6,0.1v2.4h3.9v10H29.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.5,33.1c-0.4-0.5-0.9-0.8-1.5-1.1c-0.6-0.3-1.3-0.4-2-0.4c-0.6,0-1.2,0.1-1.7,0.3c-0.5,0.2-0.9,0.5-1.4,0.9 l0,0l0.6-3.5h6.4v-2.6h-8.6l-1.5,8.5h2.8c0.3-0.4,0.6-0.7,1-0.9c0.4-0.2,0.8-0.3,1.4-0.3c0.4,0,0.8,0.1,1.1,0.2 c0.3,0.1,0.6,0.4,0.8,0.6c0.2,0.3,0.4,0.6,0.5,0.9c0.1,0.4,0.2,0.7,0.2,1.1c0,0.4-0.1,0.8-0.2,1.1c-0.1,0.4-0.3,0.7-0.5,0.9 c-0.2,0.3-0.5,0.5-0.8,0.7c-0.3,0.2-0.7,0.3-1.1,0.3c-0.7,0-1.3-0.2-1.7-0.6c-0.5-0.4-0.7-1-0.8-1.7h-3.1c0,0.8,0.2,1.5,0.5,2.1 s0.7,1.1,1.3,1.5c0.5,0.4,1.1,0.7,1.8,0.9s1.4,0.3,2.2,0.3c0.8,0,1.5-0.1,2.2-0.4c0.7-0.3,1.3-0.7,1.8-1.2c0.5-0.5,0.9-1.1,1.2-1.8 c0.3-0.7,0.5-1.4,0.5-2.2c0-0.7-0.1-1.4-0.3-2C44.2,34.1,43.9,33.6,43.5,33.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.5,11.7c-0.6,0.8-0.5,2,0.3,2.6l1.5,1.2H28.9c-10.1,0-18.3,8.2-18.3,18.3S18.8,52,28.9,52 c1,0,1.8-0.8,1.8-1.8c0-1-0.8-1.8-1.8-1.8c-8.1,0-14.6-6.6-14.6-14.6c0-8.1,6.6-14.6,14.6-14.6h11.4l-1.5,1.1 c-0.8,0.6-0.9,1.8-0.3,2.6c0.4,0.5,0.9,0.7,1.4,0.7c0.4,0,0.8-0.1,1.1-0.4l7.5-5.9l-7.5-5.9C40.3,10.8,39.1,10.9,38.5,11.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcForward15);
export default __webpack_public_path__ + "static/media/ic_forward_15.dd8639e39753edc17d04bae801d4ecb1.svg";
export { ForwardRef as ReactComponent };